import { render, staticRenderFns } from "./age.vue?vue&type=template&id=3c49568a&scoped=true"
import script from "./age.vue?vue&type=script&lang=js"
export * from "./age.vue?vue&type=script&lang=js"
import style0 from "./age.vue?vue&type=style&index=0&id=3c49568a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49568a",
  null
  
)

export default component.exports